<div class="tip" *ngIf="!flag">
  <div class="ico">!</div>
  <div class="tips">
    <div class="tip1">提醒</div>
    <div class="tip2">
      工单仅处理「账号异常 / 没有会员 /
      确认密码错误」相关问题。提交后我们可能会为您重新更换账号，请及时备份当前账号数据。
    </div>
  </div>
</div>
<div class="tip" *ngIf="flag" [ngClass]="{ error: flag }">
  <div class="ico">!</div>
  <div class="tips" *ngIf="flag">
    <div class="tip1">有工单需要补充信息</div>
    <div class="tip2">
      请进入「处理中」查看需补充的工单，并按页面提示尽量完整填写信息，信息不完整可能会延长处理时间。
    </div>
  </div>
</div>
